import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    axios.get(`${API}/stats/admin`, {
      headers: { authorization: token }
    }).then(res => setStats(res.data));
  }, [token]);

  const cards = [
    { label: tr("Foydalanuvchilar"), value: stats?.counts?.users || 0, color: '#4f8ef7' },
    { label: tr("Testlar"), value: stats?.counts?.tests || 0, color: '#f7924f' },
    { label: tr("Yangiliklar"), value: stats?.counts?.news || 0, color: '#4fc7f7' },
    { label: tr("Kitoblar"), value: stats?.counts?.books || 0, color: '#2d8a2d' },
    { label: tr("Test natijalari"), value: stats?.counts?.results || 0, color: '#7c4ff7' },
  ];

  return (
    <div>
      <h2 style={{ marginBottom: '24px', fontSize: '22px' }}>{tr("Dashboard")}</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
        {cards.map(card => (
          <div key={card.label} style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
            <p style={{ fontSize: '13px', color: '#888', marginBottom: '8px' }}>{card.label}</p>
            <p style={{ fontSize: '28px', fontWeight: '600', color: card.color }}>{card.value}</p>
          </div>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Top foydalanuvchilar")}</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '8px', color: '#888', fontWeight: '500' }}>{tr("Ism")}</th>
              <th style={{ textAlign: 'left', padding: '8px', color: '#888', fontWeight: '500' }}>{tr("Daraja")}</th>
              <th style={{ textAlign: 'left', padding: '8px', color: '#888', fontWeight: '500' }}>{tr("Bo'lim")}</th>
              <th style={{ textAlign: 'right', padding: '8px', color: '#888', fontWeight: '500' }}>{tr("Ball")}</th>
            </tr>
          </thead>
          <tbody>
            {stats?.top_users?.map(user => (
              <tr key={user.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                <td style={{ padding: '10px 8px' }}>{user.full_name}</td>
                <td style={{ padding: '10px 8px', color: '#888' }}>{user.rank}</td>
                <td style={{ padding: '10px 8px', color: '#888' }}>{user.department}</td>
                <td style={{ padding: '10px 8px', textAlign: 'right', fontWeight: '600', color: '#4f8ef7' }}>{user.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Dashboard;